module.exports = __webpack_public_path__ + "static/img/seek.03c1a4d2.png";